export const ERRORS = {
  GENERIC_ERROR: 'EXCEPTIONS.GENERIC_ERROR',
  USERS: {
    FORM: {
      INVALID_INVITATION_CODE: 'EXCEPTIONS.USERS.REGISTER.INVALID_INVITATION_CODE',
      INVALID_DOCUMENT: 'EXCEPTIONS.USERS.REGISTER.INVALID_DOCUMENT',
      INVALID_PASSWORD: 'EXCEPTIONS.USERS.REGISTER.INVALID_PASSWORD',
      NOT_AVAILABLE_INVITATION_CODE: 'EXCEPTIONS.USERS.REGISTER.NOT_AVAILABLE_INVITATION_CODE',
      REQUIRED_DOCUMENT: 'EXCEPTIONS.USERS.REGISTER.REQUIRED_DOCUMENT',
      REQUIRED_EMAIL: 'EXCEPTIONS.USERS.REGISTER.REQUIRED_EMAIL',
      REQUIRED_PHONE_NUMBER: 'EXCEPTIONS.USERS.REGISTER.REQUIRED_PHONE_NUMBER',
      REQUIRED_PROFILE: 'EXCEPTIONS.USERS.REGISTER.REQUIRED_PROFILE',
      REQUIRED_OPT_IN_PRIVACY: 'EXCEPTIONS.USERS.REGISTER.REQUIRED_OPT_IN_PRIVACY',
      REQUIRED_PASSWORD: 'EXCEPTIONS.USERS.REGISTER.REQUIRED_PASSWORD',
      NO_PAYLOAD_PROVIDED: 'EXCEPTIONS.USERS.REGISTER.NO_PAYLOAD_PROVIDED',
      DOCUMENT: 'EXCEPTIONS.USERS.REGISTER.DOCUMENT',
      EMAIL: 'EXCEPTIONS.USERS.REGISTER.EMAIL',
      PHONE_NUMBER: 'EXCEPTIONS.USERS.REGISTER.PHONE_NUMBER',
      FIRST_NAME: 'EXCEPTIONS.USERS.REGISTER.FIRST_NAME',
      LAST_NAME: 'EXCEPTIONS.USERS.REGISTER.LAST_NAME',
      OPT_IN_PRIVACY: 'EXCEPTIONS.USERS.REGISTER.OPT_IN_PRIVACY',
      BIRTH_DATE: 'EXCEPTIONS.USERS.REGISTER.BIRTH_DATE',
      LEGAL_AGE: 'EXCEPTIONS.USERS.REGISTER.LEGAL_AGE',
      PASSWORD: 'EXCEPTIONS.USERS.REGISTER.PASSWORD',
      PASSWORD_CONFIRMATION: 'EXCEPTIONS.USERS.REGISTER.PASSWORD_CONFIRMATION',
    },
  },
  INVOICES: {
    DOWNLOAD: {
      NO_URLS_DONE: 'EXCEPTIONS.INVOICES.DOWNLOAD.NO_URLS_DONE',
      AUTHORISE_POPUP_BLOCKED: 'EXCEPTIONS.INVOICES.DOWNLOAD.AUTHORISE_POPUP_BLOCKED',
    },
  },
  PAYMENT_SLIPS: {
    DOWNLOAD: {
      NO_URLS_DONE: 'EXCEPTIONS.PAYMENT_SLIPS.DOWNLOAD.NO_URLS_DONE',
      AUTHORISE_POPUP_BLOCKED: 'EXCEPTIONS.PAYMENT_SLIPS.DOWNLOAD.AUTHORISE_POPUP_BLOCKED',
      NO_RESULTS_FOUND: 'EXCEPTIONS.PAYMENT_SLIPS.DOWNLOAD.NO_RESULTS_FOUND',
    },
  },
  MY_SCANSOURCE_UI: {
    INTERNAL: {
      INVALID_DATE_START: 'EXCEPTIONS.MY_SCANSOURCE_UI.INVALID_DATE_START',
      INVALID_DATE_END: 'EXCEPTIONS.MY_SCANSOURCE_UI.INVALID_DATE_END',
    },
    END_DATE_CANNOT_BE_BEFORE_START_DATE:
      'EXCEPTIONS.MY_SCANSOURCE_UI.END_DATE_CANNOT_BE_BEFORE_START_DATE',
    FILTERS_CANNOT_BE_EMPTY: 'EXCEPTIONS.MY_SCANSOURCE_UI.FILTERS_CANNOT_BE_EMPTY',
    INVALID_COMPANY_DOCUMENT: 'EXCEPTIONS.MY_SCANSOURCE_UI.INVALID_COMPANY_DOCUMENT',
    INVALID_DOCUMENT: 'EXCEPTIONS.MY_SCANSOURCE_UI.INVALID_DOCUMENT',
    SHOULD_BE_A_COMPANY_DOCUMENT: 'EXCEPTIONS.MY_SCANSOURCE_UI.SHOULD_BE_A_COMPANY_DOCUMENT',
    GENERIC_TERM_REQUIRED: 'EXCEPTIONS.MY_SCANSOURCE_UI.GENERIC_TERM_REQUIRED',
  },
  STATUS: {
    ACCEPTED: 'SERVER.ACCEPTED',
    BAD_GATEWAY: 'SERVER.BADGATEWAY',
    BAD_REQUEST: 'SERVER.BADREQUEST',
    CREATED: 'SERVER.CREATED',
    FORBIDDEN: 'SERVER.FORBIDDEN',
    INTERNAL_SERVER_ERROR: 'SERVER.INTERNALERROR',
    NO_CONTENT: 'SERVER.NOCONTENT',
    NOT_FOUND: 'SERVER.NOTFOUND',
    OK: 'SERVER.OK',
    SERVICE_UNAVAILABLE: 'SERVER.SERVICEUNAVAILABLE',
    UNAUTHORIZED: 'SERVER.UNAUTHORIZED',
    UNPROCESSABLE_ENTITY: 'SERVER.UNPROCESSABLEENTITY',
  },
};
